import { LocationCount } from "@search/api/types";
import { LocationFacet } from "@search/components/LocationFacet";
import clsx from "clsx";

import { type CommonProps } from "@/types";

import styles from "./LocationFacets.module.css";

const ref = "location-facets";

interface LocationFacetsProps extends Partial<CommonProps> {
  locations: LocationCount;
  update: (distance: number) => void;
}

function useLocationFacets(props: LocationFacetsProps) {
  const { locations, update } = props;
  const { distances, name } = locations;
  const className = clsx(styles[ref]);

  return {
    className,
    distances,
    name,
    update,
  };
}

function LocationFacets(props: LocationFacetsProps) {
  const { className, distances, name, update } = useLocationFacets(props);

  return (
    <>
      <div className={styles["location-name"]}>{name}</div>
      {Object.entries(distances).map(([id, { distance, count }]) => (
        <div key={`region_${id}`} className={className}>
          <LocationFacet
            count={count}
            id={`location_${id}`}
            distance={distance}
            onClick={() => update(distance)}
          />
        </div>
      ))}
    </>
  );
}

export default LocationFacets;
export { LocationFacets, type LocationFacetsProps };
